module.exports = __webpack_public_path__ + "media/images/registrations/info_version/info-mobile-01-8b0070bb17273cba9ea8a249480545f3.png";